import { useState } from 'react';

export function slicePage<T>(
  items: readonly T[],
  page: number,
  pageSize: number,
): { page: number; pageItems: T[]; total: number } {
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const currentPage = Math.min(Math.max(1, page), pageCount);
  const start = (currentPage - 1) * pageSize;
  return {
    page: currentPage,
    pageItems: items.slice(start, start + pageSize),
    total: items.length,
  };
}

export function usePagedItems<T>(
  items: readonly T[],
  pageSize: number,
): {
  page: number;
  setPage: (page: number) => void;
  pageItems: T[];
  total: number;
} {
  const [page, setPage] = useState(1);
  const sliced = slicePage(items, page, pageSize);
  return {
    page: sliced.page,
    setPage,
    pageItems: sliced.pageItems,
    total: sliced.total,
  };
}
